<div class="ltms-reponse-panel" [id]="'RESPONSE'+feedId">
    
    <div class="ltms-response-body">
        <div class="label-panel">Comments</div>
        <div class="ltms-response">
            <div class="ltms-feed-comments">
                <div class="ltms-feed-comments-header">
                    <div class="ltms-feed-comments-left">
                        <div class="ltms-feed-comments-badge" [style.background]="feedDetails.primary_rating_color">
                            {{feedDetails.primary_rating}}
                            <span *ngIf="feedDetails.primary_rating == 'NA'">No rating provided by the customer</span>
                        </div>
                        <div class="ltms-feed-comments-detail">
                            <div class="ltms-feed-date-label">Received on:</div>
                            <div class="ltms-feed-recieved-date">{{feedDetails.received_on}}</div>
                        </div>
                    </div>
                    <div class="ltms-feed-comments-right" (click)="markFeedAsUnread()">
                        Mark as unread
                    </div>
                </div>
                <div class="ltms-feed-comments-body" *ngIf="feedDetails.comments && feedDetails.comments != ''">
                    “{{feedDetails.comments}}”
                </div>
                <div class="ltms-feed-comments-body no-comment" *ngIf="!feedDetails.comments || feedDetails.comments == ''">
                    No comment provided
                </div>
            </div>
            <div class="ltms-reponse-details">
                <div class="ltms-reponse-details-list"  *ngFor="let detail of fieldDetails|orderBy:'seq_no':'asc';">
                    <ng-container *ngIf="!isQuestionTypeAttachment(detail) && detail.values.length && detail.is_displayed_on_dashboard">
                        <div class="ltms-resonses-label">
                            {{detail.label}}
                        </div>
                        <div class="ltms-resonses-values" *ngFor="let value of detail.values">
                            {{value}}
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isQuestionTypeAttachment(detail) && detail.values.length && detail.is_displayed_on_dashboard">
                        <div class="ltms-resonses-label">
                            {{detail.label}}
                        </div>
                        <div class="ltms-file-list" >
                            <div class="ltms-file" *ngFor="let attachment of detail.values">
                               <span class="ltms-filename"> {{attachment.name}}{{attachment.ext}}</span>
                               <img (click)="downloadAttachment(attachment.value)" src="assets/images/download-file.svg"/>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="ltms-response-side-bar">
       <app-response-controller [feedId]="feedId" [feedData]="feedData" (loadingChange)="loadingChanged($event)" [brandDetails]="brandDetails"></app-response-controller>
    </div>
    <div class="ltms-ui-rules-overlay">
        <div class="ltms-ui-rules">
            update status
        </div>
    </div>
</div>
<div class="feed-details-loader"  *ngIf="!isControlPanelLoaded && !isResponsePanelLoaded">
    <app-ltms-loader></app-ltms-loader>
  </div>